export default __webpack_public_path__ + "static/media/iconeMensagem.93555c22.png";